import React from 'react';
import { Modal, ModalBody } from 'reactstrap';

const CopiedUTR = () => {
  return (
    <div>
      <Modal centered isOpen={true}>
        <ModalBody className='text-center'>
          <p>Notice</p>
          UTR Submit SuccessFully
        </ModalBody>
      </Modal>
    </div>
  );
};

export default CopiedUTR;
